/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FinopsAssessmentTriggerResponse {
    getFixupPrototypeFunction() { return FinopsAssessmentTriggerResponse.fixupPrototype; }

    static newInstance(model: Partial<FinopsAssessmentTriggerResponse>): FinopsAssessmentTriggerResponse {
        let obj = Object.assign(new FinopsAssessmentTriggerResponse(), model);
        FinopsAssessmentTriggerResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FinopsAssessmentTriggerResponse>): FinopsAssessmentTriggerResponse {
        if (!model) return null;
        return FinopsAssessmentTriggerResponse.newInstance(<FinopsAssessmentTriggerResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FinopsAssessmentTriggerResponse) {
        if (!obj) return;

        models.FinopsAssessmentTriggerResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FinopsAssessmentTriggerResponse): boolean {
        Object.setPrototypeOf(obj, FinopsAssessmentTriggerResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Assessment run id
     */
    assessment_run_id: string;

}
